import { nextTick } from 'vue'
import { EVENTS } from '@/shared/constants/commons'
import Events from '@/events/events'
import { notifyDevs } from '@/shared/errors/notifyDevs'
import { startGlobalDataRefresh } from '@/shared/services/globalDataRefresher.js'
import { startBalancesRefresh, isBalancesCacheStale, refreshBalances } from '@/shared/services/balancesService.js'
import { initChatWidget } from '@/features/chat/chatInit.js'

async function boot() {
  await nextTick()
  // Démarrer le rafraîchissement global des données
  startGlobalDataRefresh()
  // Démarrer le rafraîchissement périodique des soldes
  startBalancesRefresh()
  // Initialiser le widget de chat pour charger les badges et conversations
  initChatWidget()
  Events.dispatch(EVENTS.APP_READY)
  document.addEventListener('DOMContentLoaded', () => {
    const hostname = window.location.hostname
    if (hostname !== 'localhost' && hostname !== '127.0.0.1') {
      notifyDevs('👋 Un utilisateur a ouvert la plateforme')
    }
  })
}

// Exporter la fonction de rafraîchissement pour l'utiliser dans les composants
export { refreshBalances, isBalancesCacheStale }

export default boot
